module.exports = __webpack_public_path__ + "static/media/lds-logo_lt.7c8bd9c9.svg";